module.exports = __webpack_public_path__ + "img/Looks05.03a8754f.jpg";